import { render, staticRenderFns } from "./SafariAssignmentLock.vue?vue&type=template&id=5b650ff4&scoped=true&"
import script from "./SafariAssignmentLock.vue?vue&type=script&lang=js&"
export * from "./SafariAssignmentLock.vue?vue&type=script&lang=js&"
import style0 from "./SafariAssignmentLock.vue?vue&type=style&index=0&id=5b650ff4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b650ff4",
  null
  
)

export default component.exports